<!-- 成长记录详情 -->
<template>
  <div class="flex-page" v-if="detailId">
    <reply
      v-if="detail.id"
      :archivesId="detailId"
      :companyId="companyId"
      :selfId="userId"
      :contentGlobalStatus="detail.contentGlobalStatus"
      :fromType="1"
    >
      <div class="main">
        <div class="b1">
          <div class="base van-hairline--bottom">
            <div class="base-l">
              {{ detail.firstStudentName && detail.firstStudentName.slice(-2) }}
            </div>
            <div class="base-r">
              <div v-html="detail.studentName"></div>
              <div class="time">
                {{ detail.createTime | formatGoodDate }}
              </div>
            </div>
          </div>
          <div class="class-info">
            <div class="class-info-item">老师：{{ detail.operatorName }}</div>
          </div>
          <vx-mult-input-show :list="detail.content && detail.content.list"></vx-mult-input-show>
        </div>
      </div>
    </reply>

    <empty-page :show="isDeleted" tips="已被机构删除"> </empty-page>
  </div>
</template>

<script>
import Reply from '@x3/vue/comp/reply.vue';
import emptyPage from '@teacher/components/empty-page.vue';
export default {
  name: 'growup-record-detail',
  // mixins: [app.mixin.share],
  data() {
    return {
      pageTitle: '成长记录',
      // myId: app.teacher.user.id,
      detailId: '',
      companyId: '',
      userId: '',
      detail: {},
      // 回复列表
      replyList: [],
      allReplyNum: 0,
      // 显示评论输入框
      showinput: false,
      // 回复框占位文本
      replyPlaceholder: '',
      // 回复谁
      replied: '',
      repliedName: '',
      repliedType: '',
      // 要提交的回复的内容
      replyContent: '',
      isDeleted: false,
    };
  },
  // computed: {
  //   OpMarkActions() {
  //     let actions = [];
  //     if (this.detail.contentGlobalStatus !== 1) {  // 视频状态 1 合成中 2已合成 3合成失败（含失败的会优先合成失败）
  //       actions.push({ name: '分享', id: 1 });
  //     }
  //     if (app.teacher) {
  //       if (this.detail.contentGlobalStatus !== 1) {
  //         actions.push({ name: '编辑', id: 2 });
  //       }
  //       actions.push({ name: '删除', id: 3 });
  //     }
  //     return actions;
  //   },
  // },
  methods: {
    onload(list, res) {
      this.replyList = list;
      this.allReplyNum = res.page.totalCount;
    },
    render() {
      this.showLoading();
      const params = {
        archivesId: this.detailId,
      };
      if (app.parent) {
        params.parentId = app.parent.user.id;
      }
      this.$api.archivesGrowUpDetail(params).then(res => {
        this.$toast.clear();
        if (res.code === 200) {
          const item = res.data;
          if (item.students.length < 2) {
            item.studentName = `<span style="margin-right: 5px">${item.students[0].name}</span><span style="color: var(--g6);">的${item.baseArchivesTypeName}</span>`;
          } else {
            item.studentName = `<span style="margin-right: 5px">${item.students[0].name}&nbsp;&nbsp;等${item.students.length}个学员</span><span style="color: var(--g6);">的${item.baseArchivesTypeName}</span>`;
          }
          item.firstStudentName = item.students[0].name;
          this.detail = item;
        } else if (res.code == 830000404) {
          this.isDeleted = true;
        }
      });
    },
    // 回复评论
    // openInput(e, item) {
    //   if (item) {
    //     if (item.reply != this.replied) {
    //       this.replyContent = '';
    //     }
    //     this.replyPlaceholder = `回复 ${item.replyName}`;
    //     this.replied = item.reply;
    //     this.repliedName = item.replyName;
    //     this.repliedType = item.replyType;
    //   } else {
    //     this.replyPlaceholder = '说点什么吧...';
    //     this.replied = '';
    //     this.repliedName = '';
    //     this.repliedType = '';
    //   }

    //   this.showinput = true;
    //   this.$refs.replyInput.focus();
    // },
    // closeInput(e) {
    //   if (this.showinput == true) {
    //     this.showinput = false;
    //   }
    // },
    // 发送评论回复
    // async createCommentReply() {
    //   vant.Toast.loading({
    //     message: '发送中...',
    //     forbidClick: true,
    //   });
    //   await this.$api.createCommentReply({
    //     commentRecordId: this.detailId,
    //     replied: this.replied,
    //     repliedName: this.repliedName,
    //     repliedType: this.repliedType,
    //     replyContent: {
    //       list: [
    //         {
    //           type: 'text',
    //           content: this.replyContent,
    //         },
    //       ],
    //     },
    //   });
    //   vant.Toast.clear();

    //   vant.Toast.success(`${false ? '回复' : '评论'}成功`);
    //   this.replyContent = '';
    //   this.$refs.vxlist.refresh();
    // },
    // 删除自已的回复
    // async deleteCommentReply(id, index) {
    //   await this.$api.deleteCommentReply(id);
    //   this.replyList.splice(index, 1);
    //   this.allReplyNum -= 1;
    // },
  },
  created() {
    this.detailId = this.$route.params.id * 1;
    this.companyId = this.$route.params.cid * 1;
    this.userId = this.$route.params.uid * 1;
    this.render();
  },
  components: {
    Reply,
    emptyPage,
  },
};
</script>

<style lang="scss" scoped>
.flex-page {
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
}
.b1 {
  padding: 0 16px 16px 16px;
  background-color: var(--white);
  .base {
    padding: calc(var(--gap) * 16) 0;
    display: flex;
    .base-l {
      display: inline-block;
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      line-height: calc(var(--w) * 40);
      border-radius: 50%;
      background-color: var(--c1);
      color: var(--white);
      text-align: center;
      vertical-align: middle;
      margin-right: calc(var(--gap) * 8);
    }
    .base-r {
      flex: 1;
      position: relative;
      .desc {
        color: var(--g6);
      }
      .time {
        margin-top: calc(var(--gap) * 2);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        color: var(--g6);
      }
      .op-img {
        position: absolute;
        right: 0;
        width: calc(var(--w) * 16);
        height: calc(var(--w) * 16);
        padding: calc(var(--gap) * 5);
        margin: auto 0;
        top: calc(var(--w) * 7);
      }
    }
  }
  .class-info {
    padding-bottom: calc(var(--gap) * 12);
    color: var(--g6);
    .class-info-item {
      padding-top: calc(var(--gap) * 12);
      .van-rate {
        vertical-align: middle;
      }
    }
  }
}
</style>
